import firebase from "firebase";

export default {
  namespaced: true,

  state: {
    // ログインユーザーの友達情報
    loginUserFriends: [],
    // 他ユーザーの友達情報
    otherUserFriends: [],
  },

  mutations: {
    addLoginUserFriends(state: any, addFriend: any) {
      if (state.loginUserFriends.length === 0) {
        state.loginUserFriends.push(addFriend);
      } else {
        let isExistingFriend = false;
        state.loginUserFriends.forEach((existingFriend: any) => {
          if (existingFriend.userId === addFriend.userId) {
            isExistingFriend = true;
            existingFriend.friendStatus = addFriend.friendStatus;
          }
        });
        if (!isExistingFriend) state.loginUserFriends.push(addFriend);
      }
    },
    addOtherUserFriends(state: any, addFriend: any) {
      if (state.otherUserFriends.length === 0) {
        state.otherUserFriends.push(addFriend);
      } else {
        let isExistingFriend = false;
        state.otherUserFriends.forEach((existingFriend: any) => {
          if (existingFriend.userId === addFriend.userId) {
            isExistingFriend = true;
            existingFriend.friendStatus = addFriend.friendStatus;
          }
        });
        if (!isExistingFriend) state.otherUserFriends.push(addFriend);
      }
    },
    resetLoginUserFriends(state: any) {
      state.loginUserFriends = [];
    },
    resetOtherUserFriends(state: any) {
      state.otherUserFriends = [];
    }
  },

  actions: {
    // 友達申請を送ります.
    apply({ commit, rootGetters }: any, otherUser: any) {
      let promise;
      if (confirm(otherUser.userName + "さんに友達申請を行います。")) {
        const userDb = firebase.firestore().collection("users");
        const otherUserInfo = {
          friendStatus: 1,
          userAchievementPower: otherUser.userAchievementPower,
          userEmail: otherUser.userEmail,
          userId: otherUser.userId,
          userName: otherUser.userName,
          userPhotoURL: otherUser.userPhotoURL,
          userProfile: otherUser.userProfile
        };
        const loginUserInfo = {
          friendStatus: 2,
          userAchievementPower: rootGetters.loginUserInfo.userAchievementPower,
          userEmail: rootGetters.loginUserInfo.userEmail,
          userId: rootGetters.loginUserInfo.userId,
          userName: rootGetters.loginUserInfo.userName,
          userPhotoURL: rootGetters.loginUserInfo.userPhotoURL,
          userProfile: rootGetters.loginUserInfo.userProfile
        };
        promise = userDb.doc(rootGetters.loginUserId).collection("friends").doc(otherUser.userId).set({
          friendStatus: otherUserInfo.friendStatus,
          friendUserId: otherUserInfo.userId
        })
        .then(() => {
          userDb.doc(otherUser.userId).collection("friends").doc(rootGetters.loginUserId).set({
            friendStatus: loginUserInfo.friendStatus,
            friendUserId: loginUserInfo.userId
          });
          commit("addLoginUserFriends", otherUserInfo);
          commit("addOtherUserFriends", loginUserInfo);
          alert(otherUser.userName + "さんに友達申請を行いました。");
        })
        .catch(() => {
          alert(otherUser.userName + "さんへの友達申請に失敗しました。");
        })
      } else {
        return false;
      }
      return Promise.resolve(promise);
    },
    // 友達申請を承認します.
    approve({ commit, rootGetters }: any, otherUser: any) {
      let promise;
      if (confirm(otherUser.userName + "さんの友達申請を承認します。")) {
        const userDb = firebase.firestore().collection("users");
        const otherUserInfo = {
          friendStatus: 3,
          userAchievementPower: otherUser.userAchievementPower,
          userEmail: otherUser.userEmail,
          userId: otherUser.userId,
          userName: otherUser.userName,
          userPhotoURL: otherUser.userPhotoURL,
          userProfile: otherUser.userProfile
        };
        const loginUserInfo = {
          friendStatus: 3,
          userAchievementPower: rootGetters.loginUserInfo.userAchievementPower,
          userEmail: rootGetters.loginUserInfo.userEmail,
          userId: rootGetters.loginUserInfo.userId,
          userName: rootGetters.loginUserInfo.userName,
          userPhotoURL: rootGetters.loginUserInfo.userPhotoURL,
          userProfile: rootGetters.loginUserInfo.userProfile
        };
        promise = userDb.doc(rootGetters.loginUserId).collection("friends").doc(otherUser.userId).set({
          friendStatus: otherUserInfo.friendStatus,
          friendUserId: otherUserInfo.userId
        })
        .then(() => {
          userDb.doc(otherUser.userId).collection("friends").doc(rootGetters.loginUserId).set({
            friendStatus: loginUserInfo.friendStatus,
            friendUserId: loginUserInfo.userId
          });
          commit("addLoginUserFriends", otherUserInfo);
          commit("addOtherUserFriends", loginUserInfo);
          alert(otherUser.userName + "さんに友達申請を承認しました。");
        })
        .catch(() => {
          alert(otherUser.userName + "さんへの友達申請の承認に失敗しました。");
        });
      } else {
        return false;
      }
      return Promise.resolve(promise);
     },
    // 友達申請を中止します.
    discontinue({ commit, rootGetters }: any, otherUser: any) {
      let promise;
      if (confirm(otherUser.userName + "さんの友達申請を中止します。")) {
        const userDb = firebase.firestore().collection("users");
        const otherUserInfo = {
          friendStatus: 0,
          userAchievementPower: otherUser.userAchievementPower,
          userEmail: otherUser.userEmail,
          userId: otherUser.userId,
          userName: otherUser.userName,
          userPhotoURL: otherUser.userPhotoURL,
          userProfile: otherUser.userProfile
        };
        const loginUserInfo = {
          friendStatus: 0,
          userAchievementPower: rootGetters.loginUserInfo.userAchievementPower,
          userEmail: rootGetters.loginUserInfo.userEmail,
          userId: rootGetters.loginUserInfo.userId,
          userName: rootGetters.loginUserInfo.userName,
          userPhotoURL: rootGetters.loginUserInfo.userPhotoURL,
          userProfile: rootGetters.loginUserInfo.userProfile
        };
        promise = userDb.doc(rootGetters.loginUserId).collection("friends").doc(otherUser.userId).set({
          friendStatus: otherUserInfo.friendStatus,
          friendUserId: otherUserInfo.userId
        })
        .then(() => {
          userDb.doc(otherUser.userId).collection("friends").doc(rootGetters.loginUserId).set({
            friendStatus: loginUserInfo.friendStatus,
            friendUserId: loginUserInfo.userId
          });
          commit("addLoginUserFriends", otherUserInfo);
          commit("addOtherUserFriends", loginUserInfo);
          alert(otherUser.userName + "さんへの友達申請を中止しました。");
        })
        .catch(() => {
          alert(otherUser.userName + "さんへの友達申請の中止に失敗しました。");
        });
      } else {
        return false;
      }
      return Promise.resolve(promise);
    },
    // ログインユーザーの友達情報を取得します.
    fetchLoginUserFriends({ commit }: any, userId: string) {
      commit("resetLoginUserFriends");
      const userDb = firebase.firestore().collection("users");
      userDb.doc(userId).collection("friends").get()
      .then((friendSnapshot) => {
        friendSnapshot.forEach((friendDoc) => {
          userDb.doc(friendDoc.data().friendUserId).get().then((friendUserDoc) =>{
            const friend: any = friendUserDoc.data();
            friend.friendStatus = friendDoc.data().friendStatus;
            commit("addLoginUserFriends", friend);
          })
        });
      });
    },
    // 他ユーザーの友達情報を取得します.
    fetchOtherUserFriends({ commit }: any, userId: string) {
      commit("resetOtherUserFriends");
      const userDb = firebase.firestore().collection("users");
      const promise = userDb.doc(userId).collection("friends").get()
      .then(friendSnapshot => friendSnapshot.forEach((friendDoc) => {
        userDb.doc(friendDoc.data().friendUserId).get().then((friendUserDoc) =>{
          const friend: any = friendUserDoc.data();
          friend.friendStatus = friendDoc.data().friendStatus;
          commit("addOtherUserFriends", friend);
        })
      }));
      return Promise.resolve(promise);
    },
    // 友達申請を拒否します.
    reject({ commit, rootGetters }: any, otherUser: any) {
      let promise;
      if (confirm(otherUser.userName + "さんからの友達申請を拒否します。")) {
        const userDb = firebase.firestore().collection("users");
        const otherUserInfo = {
          friendStatus: 0,
          userAchievementPower: otherUser.userAchievementPower,
          userEmail: otherUser.userEmail,
          userId: otherUser.userId,
          userName: otherUser.userName,
          userPhotoURL: otherUser.userPhotoURL,
          userProfile: otherUser.userProfile
        };
        const loginUserInfo = {
          friendStatus: 0,
          userAchievementPower: rootGetters.loginUserInfo.userAchievementPower,
          userEmail: rootGetters.loginUserInfo.userEmail,
          userId: rootGetters.loginUserInfo.userId,
          userName: rootGetters.loginUserInfo.userName,
          userPhotoURL: rootGetters.loginUserInfo.userPhotoURL,
          userProfile: rootGetters.loginUserInfo.userProfile
        };
        promise = userDb.doc(rootGetters.loginUserId).collection("friends").doc(otherUser.userId).set({
          friendStatus: otherUserInfo.friendStatus,
          friendUserId: otherUserInfo.userId
        })
        .then(() => {
          userDb.doc(otherUser.userId).collection("friends").doc(rootGetters.loginUserId).set({
            friendStatus: loginUserInfo.friendStatus,
            friendUserId: loginUserInfo.userId
          });
          commit("addLoginUserFriends", otherUserInfo);
          commit("addOtherUserFriends", loginUserInfo);
          alert(otherUser.userName + "さんからの友達申請を拒否しました。");
        })
        .catch(() => {
          alert(otherUser.userName + "さんからの友達申請の拒否に失敗しました。");
        });
      } else {
        return false;
      }
      Promise.resolve(promise);
    },
    // 友達関係を解除します.
    release({ commit, rootGetters }: any, otherUser: any) {
      let promise;
      if (confirm(otherUser.userName + "さんとの友達関係を解除します。")) {
        const userDb = firebase.firestore().collection("users");
        const otherUserInfo = {
          friendStatus: 0,
          userAchievementPower: otherUser.userAchievementPower,
          userEmail: otherUser.userEmail,
          userId: otherUser.userId,
          userName: otherUser.userName,
          userPhotoURL: otherUser.userPhotoURL,
          userProfile: otherUser.userProfile
        };
        const loginUserInfo = {
          friendStatus: 0,
          userAchievementPower: rootGetters.loginUserInfo.userAchievementPower,
          userEmail: rootGetters.loginUserInfo.userEmail,
          userId: rootGetters.loginUserInfo.userId,
          userName: rootGetters.loginUserInfo.userName,
          userPhotoURL: rootGetters.loginUserInfo.userPhotoURL,
          userProfile: rootGetters.loginUserInfo.userProfile
        };
        promise = userDb.doc(rootGetters.loginUserId).collection("friends").doc(otherUser.userId).set({
          friendStatus: otherUserInfo.friendStatus,
          friendUserId: otherUserInfo.userId
        })
        .then(() => {
          userDb.doc(otherUser.userId).collection("friends").doc(rootGetters.loginUserId).set({
            friendStatus: loginUserInfo.friendStatus,
            friendUserId: loginUserInfo.userId
          });
          commit("addLoginUserFriends", otherUserInfo);
          commit("addOtherUserFriends", loginUserInfo);
          alert(otherUser.userName + "さんとの友達関係を解除しました。");
        })
        .catch(() => {
          alert(otherUser.userName + "さんとの友達関係の解除に失敗しました。");
        });
      } else {
        return false;
      }
      Promise.resolve(promise);
    },
  },

  getters: {
    // ログインユーザーの友達情報
    loginUserFriends: (state: any) => (state.loginUserFriends ? (state as any).loginUserFriends : ""),
    // 他ユーザーの友達情報
    otherUserFriends: (state: any) => (state.otherUserFriends ? (state as any).otherUserFriends : ""),
  },
};
